import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import JournalManagement from "@/views/JournalView/JournalManagement.vue";
import CreateJournal from "@/views/JournalView/CreateJournal.vue";
import EditJournal from "@/views/JournalView/EditJournal.vue";
import ShowJournal from "@/views/JournalView/ShowJournal.vue";
import ConsentDocumentManagement from "@/views/JournalView/ConsentDocumentManagement.vue";
import CreateConsentDocument from "@/views/JournalView/CreateConsentDocument.vue";
import ShowConsentDocument from "@/views/JournalView/ShowConsentDocument.vue";
import PaperPublishManagement from "@/views/JournalView/PaperPublishManagement.vue";
import JournalPublishManagement from "@/views/JournalView/JournalPublishManagement.vue";
import EditJournalContent from "@/views/JournalView/EditJournalContent.vue";
import EditPublishedPaper from "@/views/JournalView/EditPublishedPaper.vue";
import JournalArchive from "@/views/AdminView/JournalArchive.vue";

const journalMenu = {
  path: "/journals",
  component: DashboardLayout,
  redirect: "/journals/management",
  name: "journals",
  children: [
    /**
     * ********************************************************************************************************
     * 간행물 관리
     * ********************************************************************************************************
     */
    {
      path: "management",
      name: "journals-management",
      component: JournalManagement,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.journal_list",
      },
    },
    {
      path: "create",
      name: "create-journal",
      component: CreateJournal,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.create_journal",
      },
    },
    {
      path: "edit/:idx",
      name: "edit-journal",
      component: EditJournal,
      props: true,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.edit_journal",
      },
    },
    {
      path: "detail/:idx",
      name: "journal-detail",
      component: ShowJournal,
      props: true,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.journal_detail",
      },
    },
    /**
     * ********************************************************************************************************
     * 동의서 관리
     * ********************************************************************************************************
     */
    {
      path: "consent-documents/management",
      name: "consent-document-management",
      component: ConsentDocumentManagement,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.consent_document_list",
      },
    },
    {
      path: "consent-documents/create",
      name: "create-consent-document",
      component: CreateConsentDocument,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.create_consent_document",
      },
    },
    {
      path: "consent-documents/:idx",
      name: "show-consent-document",
      component: ShowConsentDocument,
      props: true,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.detail_consent_document",
      },
    },
    /**
     * ********************************************************************************************************
     * 게재 논문 관리
     * ********************************************************************************************************
     */
    {
      path: "papers/publish",
      name: "paper-publish-management",
      component: PaperPublishManagement,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.paper_publish_management",
      },
    },
    {
      path: "papers/edit/:idx",
      name: "edit-published-paper",
      component: EditPublishedPaper,
      props: true,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.edit_published_paper",
      },
    },
    /**
     * ********************************************************************************************************
     * 간행물 발행 관리
     * ********************************************************************************************************
     */
    {
      path: "publish",
      name: "journal-publish-management",
      component: JournalPublishManagement,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.journal_publish_management",
      },
    },
    {
      path: "archives",
      name: "journal-archives",
      component: JournalArchive,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "editor", "master"],
        title: "topnav.journal_archive",
      },
    },
    {
      path: ":idx/contents/edit",
      name: "edit-journal-content",
      component: EditJournalContent,
      props: true,
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "topnav.edit_journal_content",
      },
    },
  ],
};

export default journalMenu;
